// getting the logged in management's data
export const MNGT_DATA_FETCHED = "MNGT_DATA_FETCHED";

export const getMngtData = (data) => ({
  type: MNGT_DATA_FETCHED,
  payload: data,
});
